/**
 * Import constants
 */
import { GET_SEARCH_DATA_PENDDING, GET_SEARCH_DATA, GET_SEARCH_DATA_ERROR } from '../actions/constants';

/**
 * Initial state
 */
const initialState = {
	loading: true,
	data: [],
	error: null
};

/**
 * Summary data reducer
 * @param {*} state
 * @param {*} action
 */
export const searchReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_SEARCH_DATA_PENDDING:
			return {
				...state,
				loading: true
			};
		case GET_SEARCH_DATA:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null
			};
		case GET_SEARCH_DATA_ERROR:
			return {
				...state,
				loading: true,
				error: action.payload
			};
		default:
			return state;
	}
};
